<template>
  <main class="main-container">
    <div class="row">
      <div class="col s12 l8 offset-l2 card-panel">
        <h3 style="text-align: center">Recargas sin usuario</h3>
        <div class="row">
          <div class="input-field col s12 l6 offset-l3 ">
            <i class="icons-in-form large material-icons prefix ">block</i>
            <input
                v-model="maxRecargas"
                id="maxRecargas"
                type="number"
                min="1"
                max="2000"
            />
            <label for="maxRecargas">Máximo de recargas al día</label>
          </div>
        </div>
        <div class="row">
          <div class="col s2 offset-s9 l1 offset-l10  waves-effect waves-light btn tooltipped blue-grey darken-3"
               @click="enviar"
               data-position="bottom"
               data-tooltip="Guardar"
          >

            <span class="material-symbols-outlined btn-style" >
              check
            </span>
          </div>

        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { configRecargasSinUsuario } from "@/api/api";

export default {
  name: "configRecargasSinUsuario",
  data() {
    return {
      nivel: localStorage.nivel,
      maxRecargas: localStorage.maxRecargas,
    };
  },
  methods: {
    enviar() {
      let objetoaEnviar = {};
      objetoaEnviar.maxRecargas = this.maxRecargas;

      configRecargasSinUsuario(objetoaEnviar)
        .then((respuesta) => {
          console.log(respuesta);
          localStorage.maxRecargas = this.maxRecargas
          M.toast({
            html: `Configuración realizada`,
            classes: "rounded",
            displayLength: 3000,
          });
        })
        .catch((error) => {
          console.log(error);
          M.toast({
            html: `Error en configuración`,
            classes: "rounded",
            displayLength: 3000,
          });
        });
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        M.updateTextFields();
      }, 5);
    });
  },
};
</script>

<style scoped>
.main {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-panel {
  border-radius: 10px;
}

.main-container {
  width: 94%;
  margin: 0 auto;
}

.btn-style {
  margin-top: 5px;
}
</style>
